import { useNavigate } from 'react-router-dom';
import { Lock, ArrowDownToLine, Timer, Scale, FileText } from 'lucide-react';
import { Toast, type ToastTone } from '@nextdone/ui';
import { useStore } from '../store/store';
import { hapticTick } from '../lib/haptics';

const ICONS: Record<ToastTone, typeof Lock> = {
  locked: Lock,
  released: ArrowDownToLine,
  timer: Timer,
  dispute: Scale,
  neutral: FileText,
};

/** Counterparty events surface here — proposals landing, money moving.
 * Tap opens the surface the event happened on. */
export function ToastHost() {
  const { state, dismissToast } = useStore();
  const navigate = useNavigate();

  if (state.toasts.length === 0) return null;
  return (
    /* z sits under DoneWipe (60) and Dialog (100): settlement owns the screen. */
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[55] w-full max-w-app px-gutter flex flex-col gap-2 pointer-events-none">
      {state.toasts.map((t) => {
        const Icon = ICONS[t.tone];
        return (
          <button
            key={t.id}
            type="button"
            className="pointer-events-auto text-left border-none bg-transparent p-0 cursor-pointer w-full"
            onClick={() => {
              hapticTick();
              dismissToast(t.id);
              if (t.to) navigate(t.to);
            }}
          >
            <Toast tone={t.tone} icon={<Icon size={16} strokeWidth={1.75} />} detail={t.detail}>
              {t.text}
            </Toast>
          </button>
        );
      })}
    </div>
  );
}
